@if (submission) {
<div class="rvd-wrapper">

    <!-- ── Navigation bar ── -->
    @if (showNav) {
    <div class="rvd-navbar osd-navbar">
        <div class="rvd-navbar-nav">
            <button class="rvd-nav-btn" (click)="prev.emit()" [disabled]="!hasPrev">‹ Prev</button>
            <span class="rvd-nav-count">{{ currentIndex + 1 }} of {{ total }}</span>
            <button class="rvd-nav-btn" (click)="next.emit()" [disabled]="!hasNext">Next ›</button>
        </div>
    </div>
    }

    <!-- ── Body ── -->
    <div class="rvd-body mb-3">

        <!-- LEFT: photos -->
        <div class="rvd-left">
            <div class="rvd-left-header">
                <span class="rvd-left-title">Operation photos</span>
                <span class="rvd-status-badge" [ngClass]="statusClass">{{ submission.status }}</span>
                <span class="rvd-ride-ref">#{{ submission.id }}</span>
            </div>

            <div class="rvd-photo-grid">
                @for (photo of photos; track photo.label; let i = $index) {
                <div class="rvd-photo-cell rvd-photo-cell--clickable" [class.rvd-photo-cell--parking]="i === 0"
                    (click)="openLightbox(i)" (keyup.enter)="openLightbox(i)" tabindex="0" role="button">
                    <span class="rvd-photo-label">{{ photo.label }}</span>
                    <img [src]="photo.url" [alt]="photo.label" class="rvd-photo-img" />
                </div>
                } @empty {
                <div class="rvd-photo-cell rvd-photo-cell--parking">
                    <div class="rvd-photo-empty"><span class="rvd-camera-icon">📷</span></div>
                </div>
                }
            </div>

            <div class="rvd-left-footer">
                <span>{{ photos.length }} photo{{ photos.length !== 1 ? 's' : '' }}</span>
            </div>

            @if (isPending && canReview) {
            <div class="rvd-actions">
                <button class="rvd-btn rvd-btn--reject" (click)="reject.emit()">✕  Reject</button>
                <button class="rvd-btn rvd-btn--approve" (click)="approve.emit()">✔  Approve</button>
            </div>
            }
        </div>

        <!-- RIGHT: info -->
        <div class="rvd-right">

            <!-- Submission -->
            <div class="rvd-card">
                <h4 class="rvd-card-title">Submission</h4>
                <div class="rvd-grid">
                    <div class="rvd-field">
                        <span class="rvd-label">SUBMISSION ID</span>
                        <span class="rvd-value">#{{ submission.id }}</span>
                    </div>
                    <div class="rvd-field">
                        <span class="rvd-label">SUBMITTED</span>
                        <span class="rvd-value">{{ submission.createdAt | date:'dd MMM yyyy, hh:mm a' }}</span>
                    </div>
                    <div class="rvd-field">
                        <span class="rvd-label">PREVIOUS CAR STATUS</span>
                        <span class="rvd-value">{{ (submission.previousStatus | titlecase) || '—' }}</span>
                    </div>
                    <div class="rvd-field">
                        <span class="rvd-label">REVIEWED</span>
                        <span class="rvd-value">{{ submission.reviewedAt ? (submission.reviewedAt | date:'dd MMM yyyy, hh:mm a') : '—' }}</span>
                    </div>
                    @if (submission.reviewComment) {
                    <div class="rvd-field rvd-field--full">
                        <span class="rvd-label">REVIEW COMMENT</span>
                        <span class="rvd-value">{{ submission.reviewComment }}</span>
                    </div>
                    }
                </div>
            </div>

            <!-- Driver -->
            <div class="rvd-card">
                <h4 class="rvd-card-title">Driver</h4>
                <div class="rvd-customer-row">
                    <div class="rvd-avatar">{{ driverInitials }}</div>
                    <div class="rvd-customer-meta">
                        <span class="rvd-customer-name">{{ submission.employeeName }}</span>
                        <span class="rvd-customer-sub">{{ submission.employeeEmail }}</span>
                    </div>
                </div>
                <div class="rvd-grid mt-10">
                    <div class="rvd-field rvd-field--full">
                        <span class="rvd-label">DRIVER LOCATION</span>
                        @if (submission.driverLatitude && submission.driverLongitude) {
                        <button type="button" class="rvd-link"
                            (click)="openMap(submission.driverLatitude, submission.driverLongitude)">Show</button>
                        } @else {
                        <span class="rvd-value">N/A</span>
                        }
                    </div>
                </div>
            </div>

            <!-- Car -->
            <div class="rvd-card">
                <h4 class="rvd-card-title">Car</h4>
                <div class="rvd-car-main-row">
                    <div class="rvd-car-thumb">
                        @if (submission.carImageUrl) {
                        <img [src]="submission.carImageUrl" alt="Car" class="rvd-car-thumb-img" />
                        } @else {
                        <span class="rvd-car-thumb-icon">📷</span>
                        }
                    </div>
                    <div class="rvd-car-info">
                        <a class="rvd-link" [routerLink]="['/vehicles', submission.carId]">{{ submission.plateNo }}</a>
                        @if (submission.carMaker || submission.carModel) {
                        <span class="rvd-car-model">{{ submission.carMaker }} {{ submission.carModel }}</span>
                        }
                    </div>
                </div>
                <div class="rvd-grid mt-10">
                    <div class="rvd-field rvd-field--full">
                        <span class="rvd-label">CAR LOCATION</span>
                        @if (submission.carLatitude && submission.carLongitude) {
                        <button type="button" class="rvd-link"
                            (click)="openMap(submission.carLatitude, submission.carLongitude)">Show</button>
                        } @else {
                        <span class="rvd-value">N/A</span>
                        }
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
}

<!-- ── Lightbox ── -->
@if (lightboxOpen && lightboxPhoto) {
<div class="rvd-lightbox-backdrop" (click)="lightboxOpen = false" (keyup.escape)="lightboxOpen = false" tabindex="0" role="dialog" aria-modal="true">
    <div class="rvd-lightbox" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" tabindex="-1">
        <div class="rvd-lightbox-header">
            <span class="rvd-lightbox-title">Submission #{{ submission.id }} · {{ lightboxPhoto.label }}</span>
            <button class="rvd-lightbox-close" (click)="lightboxOpen = false">✕</button>
        </div>
        <div class="rvd-lightbox-body">
            <button type="button" class="rvd-lightbox-nav rvd-lightbox-nav--prev" (click)="lightboxPrev()" [disabled]="lightboxIndex === 0">&#8249;</button>
            <img [src]="lightboxPhoto.url" [alt]="lightboxPhoto.label" class="rvd-lightbox-img" />
            <button type="button" class="rvd-lightbox-nav rvd-lightbox-nav--next" (click)="lightboxNext()" [disabled]="lightboxIndex === photos.length - 1">&#8250;</button>
        </div>
    </div>
</div>
}
